export default "__VITE_ASSET__yxrhIO8n__"